import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const notion = defineConnector({
  identifier: "notion",
  name: "Notion",
  tagLine: "Connected workspace",
  logo,
  protocol: "http",
  tags: ["featured", "productivity", "documents"],
  defaultUrlPattern: () => "https://api\\.notion\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: `Bearer ${app.oauthToken.accessToken}`,
      },
      { name: "Notion-Version", value: "2022-06-28" },
    ]),
  steps: [
    {
      title: "Connect your Notion workspace",
      items: [
        {
          kind: "oauth",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://api.notion.com/v1/oauth/authorize",
    tokenEndpoint: () => "https://api.notion.com/v1/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_basic_no_urlencode",
    clientCredentialsFrom: "env",
    authorizationParameters: () => ({
      owner: "user",
    }),
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.notion.com/v1/users/me",
  },
});
